const TOKEN_STORAGE_KEY = "token";

export const getStoredAuthToken = () => {
  if (typeof window === "undefined") return "";
  return window.localStorage.getItem(TOKEN_STORAGE_KEY) || "";
};

export const clearStoredAuth = () => {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(TOKEN_STORAGE_KEY);
  window.localStorage.removeItem("userSub");
};

function parseJwt(token) {
  if (!token || typeof token !== "string") return null;

  try {
    const base64Url = token.split(".")[1];
    if (!base64Url) return null;

    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split("")
        .map((character) => {
          return `%${`00${character.charCodeAt(0).toString(16)}`.slice(-2)}`;
        })
        .join(""),
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    return null;
  }
}

export const hasValidAuthToken = (token = getStoredAuthToken()) => {
  const payload = parseJwt(token);
  if (!payload) return false;

  if (payload.exp == null) return true;

  const expiryTime = Number(payload.exp);
  if (!Number.isFinite(expiryTime)) return false;

  return expiryTime * 1000 > Date.now();
};

export const getAuthenticatedUser = (token = getStoredAuthToken()) => {
  if (!hasValidAuthToken(token)) return null;
  return parseJwt(token);
};

export default parseJwt;
